import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    layout: 'login',
    isLoading: false,
    progress: 0,
    user: null,
    core_compay: localStorage.getItem('core_compay') || null,
    company_obj: JSON.parse(localStorage.getItem('company_obj')) || null,
    store_obj: JSON.parse(localStorage.getItem('store_obj')) || null,
    settings_obj: JSON.parse(localStorage.getItem('settings')) || null,
    book_diary: JSON.parse(localStorage.getItem('book_diary')) || null,
    token: JSON.parse(localStorage.getItem('_token')) || false,
    date_period_i: null,
  },
  mutations: {
    SET_AUTH(state, user) {
      let secuntuser = user;
      state.token = true;
      if (!user) {
        state.token = false;
        secuntuser = {
          first_name: '',
          last_name: '',
          email: '',
          exp: '',
        };
      }
      state.user = secuntuser;
    },
    SET_LAYOUT(state, name) {
      state.layout = name;
    },
    SET_status_request(state, status) {
      state.progress = status;
      if (!status) {
        state.progress = 0;
      }
    },
    set_settings(state, settings) {
      let temp = settings;
      if (!settings) {
        temp = {};
      }
      state.settings_obj = temp;
    },
    set_avatar_url(state, avatarUrl) {
      state.settings_obj.avatar_url = avatarUrl;
    },
    set_avatar_id(state, avatarId) {
      state.settings_obj.avatar = avatarId;
    },
    set_core_company(state, coreCompay) {
      state.core_compay = coreCompay;
    },
    set_company(state, companyObj) {
      state.company_obj = companyObj;
    },
    set_book_diary(state, bookDiary) {
      state.book_diary = bookDiary;
    },
    set_date_period_i(state, datePeriodI) {
      state.date_period_i = datePeriodI;
    },
    set_store(state, storeObj) {
      state.store_obj = storeObj;
    },
  },
  getters: {
    is_login(state) {
      return state.token;
    },
    register(state) {
      return state.token;
    },
    student_name(state) {
      return state.settings_obj.student_name;
    },
    get_core_compay(state) {
      return state.core_compay;
    },
    get_compay(state) {
      return state.company_obj;
    },
    get_store(state) {
      return state.store_obj;
    },
    get_book_diary(state) {
      return state.book_diary;
    },
    get_date_period_i(state) {
      return state.date_period_i;
    },
  },
  actions: {
    status_request({ commit }, { progress }) {
      commit('SET_status_request', progress);
    },
    reset_status_request({ commit }) {
      commit('RESET_status_request', null);
    },
    set_data_settgins({ commit }, { settings }) {
      commit('set_settings', settings);
    },
    set_avatar_url({ commit }, { avatarUrl }) {
      commit('set_avatar_url', avatarUrl);
    },
    set_avatar_id({ commit }, { avatarId }) {
      commit('set_avatar_id', avatarId);
    },
    set_core_company({ commit }, { coreCompay }) {
      localStorage.setItem('coreCompay', coreCompay);
      commit('set_core_company', coreCompay);
    },
    set_company({ commit }, { companyObj }) {
      localStorage.setItem('company_obj', JSON.stringify(companyObj));
      localStorage.removeItem('store_obj');
      commit('set_company', companyObj);
    },
    set_book_diary({ commit }, { bookDiary }) {
      localStorage.setItem('book_diary', JSON.stringify(bookDiary));
      commit('set_book_diary', bookDiary);
    },
    set_date_period_i({ commit }, { datePeriodI }) {
      localStorage.setItem('date_period_i', JSON.stringify(datePeriodI));
      commit('set_date_period_i', datePeriodI);
    },
    set_store({ commit }, { storeObj }) {
      localStorage.setItem('store_obj', JSON.stringify(storeObj));
      commit('set_store', storeObj);
    },
    login({ commit }, { user }) {
      commit('SET_AUTH', user);
    },
    logout({ commit }) {
      // se setea a null el objeto user
      commit('SET_AUTH', null);
      // se remueve la data de locall storage
      window.localStorage.clear();
      // localStorage.removeItem('user');
      // localStorage.removeItem('_token');
    },
  },
  modules: {
  },
});
